import { EventsBySportIdRequest } from "../../contracts";
import { getEachWayTitle } from "../getEachWayTitle";
export const getEventTitle = (event, market, eachWayString) => {
    if (event.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString()) {
        const placeTerm = parseInt(market.metadata.placeTermsId);
        const oddsTerms = parseInt(market.metadata.oddsTermsId);
        const eachWay = oddsTerms && placeTerm
            ? getEachWayTitle(eachWayString, placeTerm, oddsTerms)
            : "";
        return `${event.eventName} ${eachWay} ${event.eventDate} | ${event.eventTime}`;
    }
    return event.eventName;
};
//# sourceMappingURL=getEventTitle.js.map